import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: ${props => props.backgroundColor};
  z-index: 2147483646;
  overflow-y: auto;
  animation-duration: ${props => (props.isClosing ? '1.2s' : '.3s')};
`

const ModalHeader = styled.div`
  width: 100%;
  height: 80px;
  background: #f5f5f5;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
`

const ModalHeaderInner = styled.div`
  position: relative;
  width: 740px;
  height: 100%;
  margin: 0 auto;
`

const ModalBody = styled.div`
  position: relative;
  width: 740px;
  height: 100%;
  margin: 0 auto;
  padding: ${props => props.padding};
  text-align: center;
  width: -moz-max-content;
`

const Container = styled.div`
  animation-duration: ${props =>
    props.isClosing
      ? '.3s'
      : props.shouldAnimationPlayFaster
      ? '0.4s'
      : '.75s'};
`

export default class ModalFullScreen extends Component {
  constructor(props) {
    super(props)
    this.onEscapeBound = this.onEscape.bind(this)
  }

  componentDidMount() {
    document.body.classList.add('no-scroll')
    document.addEventListener('keyup', this.onEscapeBound)
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
    document.removeEventListener('keyup', this.onEscapeBound)
  }

  onEscape(e) {
    // ESC key
    if (
      e.keyCode === 27 &&
      this.props.allowEscape &&
      this.props.closeCallback
    ) {
      this.props.closeCallback()
    }
  }

  render() {
    const {
      headerContents,
      children,
      isClosing,
      padding,
      animate,
      backgroundColor,
      bodyStyles,
      shouldAnimationPlayFaster
    } = this.props
    return (
      <Background
        className={
          animate ? `animated ${!isClosing ? 'fadeIn' : 'fadeOut'}` : ''
        }
        isClosing={isClosing}
        backgroundColor={backgroundColor}
        onClick={
          this.props.allowCloseOnExternalClick
            ? () => {
                this.props.closeCallback()
              }
            : null
        }
      >
        <Container
          className={
            animate ? `animated ${!isClosing ? 'fadeInDown' : 'fadeOutUp'}` : ''
          }
          isClosing={isClosing}
          shouldAnimationPlayFaster={shouldAnimationPlayFaster}
        >
          {headerContents && (
            <ModalHeader>
              <ModalHeaderInner>{headerContents}</ModalHeaderInner>
            </ModalHeader>
          )}
          <ModalBody padding={padding} style={bodyStyles}>
            {children}
          </ModalBody>
        </Container>
      </Background>
    )
  }
}

ModalFullScreen.defaultProps = {
  allowEscape: false,
  animate: true,
  backgroundColor: '#f5f5f5',
  allowCloseOnExternalClick: false
}

ModalFullScreen.propTypes = {
  children: PropTypes.array,
  headerContents: PropTypes.object,
  closeCallback: PropTypes.func,
  allowEscape: PropTypes.bool,
  isClosing: PropTypes.bool,
  padding: PropTypes.string,
  animate: PropTypes.bool,
  backgroundColor: PropTypes.string,
  allowCloseOnExternalClick: PropTypes.bool,
  bodyStyles: PropTypes.object,
  shouldAnimationPlayFaster: PropTypes.bool
}
